import './Register.css';
import { useState,useEffect } from 'react';
import Signin from '../Signin/Signin';
import { useSocket } from '../../context/socketContext';
function Register({onPageRouteChange}) {
  const [RegisterRoute,setRegisterRoute]=useState('Register');
  const [registerUsername,setRegisterUsername]=useState('');
  const [registerPassword,setRegisterPassword]=useState('');
  const [registerState,setRegisterState]=useState(false);
  const {globalUserName,setGlobalUserName}=useSocket();

  const onRegisterChange=(desiredChoice)=>{
    if(desiredChoice==='Home'){
      document.getElementById('formDisplayer').style.visibility='hidden';
      document.getElementById('Signinback').style.visibility='hidden';
      document.getElementById("Home").style.overflowY="visible";
      document.getElementById("Home").style.height="auto";
      document.getElementById("Home").style.position="relative";
   }else{
      setRegisterRoute(desiredChoice);
   }
  }
  function clickOnChangeRegister(){
    
    fetch('https://nestjs-socket-server-production.up.railway.app/users/register', {
        method: 'POST', // or 'PUT'
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username:registerUsername,
          password:registerPassword
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          setRegisterState(data);
          
        })
        .catch((error) => {
          console.error('Error:', error);
        });
        if(registerState){
          onPageRouteChange();
          setGlobalUserName(registerUsername);

        }
        
      }
      const setUserName2 = (event)=>{
        // show the user input value to console
        setRegisterUsername(event.target.value);
      };
      const setPassWord2 = (event)=>{
        // show the user input value to console
        setRegisterPassword(event.target.value);
  
      };
  return (
    <div>
      {RegisterRoute==='Register'?
        <div className="Register">
          <div className='RegisterForm'>
              <h1 onClick={()=>onRegisterChange('Home')} className='quit'>X</h1>
              <div>
                  <h1>Register</h1>
                  <div>
                      <input onChange={setUserName2}></input>
                  </div>
                  
                  <div>
                      <input onChange={setPassWord2}></input>
                  </div>
                  {/* onClick={setRegisterRoute('Home')} */}
                  <div >
                      <button onClick={clickOnChangeRegister}>Register</button>
                      <h3>have an account?</h3>
                      <button onClick={()=>onRegisterChange('Signin')}>Sign in</button>

                  </div>    
              </div>        
          </div>
      </div>
      :
      <div className='SigninWrapper'>
        <Signin onPageRouteChange={onPageRouteChange}/>
      </div>
      }
    </div>
  );
}

export default Register;
